import { useMemo } from "react";
import GoogleMapsAPILoader from '../../services/GoogleMaps.service';
import { AUBERGINE } from './MapTheme';



export default function MapContainer({handleMarkerUpdate, position, zoom}) {


  const initMap = async (data) => {

    const mapOptions = {
      center: {
        lat: position.lat || 24,
        lng: position.lng || 54,
      },
      zoom: zoom || 2,
      disableDefaultUI: true,
      styles: AUBERGINE
    };

    GoogleMapsAPILoader.load().then((google) => {
      var map = new google.maps.Map(
        document.getElementById("map"),
        mapOptions
      );

      let marker;

      marker = new google.maps.Marker({
        position: (position.lat && position.lng) ?  position : mapOptions.center,
        map: map,
        title: "Hello World!",
      });

      map.addListener("click", (e) => {
       // setPostion({ latitude: e.latLng.lat(), longitude: e.latLng.lng() });
        marker.setMap(null);
        handleMarkerUpdate({ latitude: e.latLng.lat(), longitude: e.latLng.lng() }, map.getZoom());
        marker = new google.maps.Marker({
          position: e.latLng,
          map,
          title: "Hello World!",
        });
      });
    });
  };

  // eslint-disable-next-line
  const memoized  = useMemo(() => initMap({position, zoom}), [position.lat, position.lng, zoom]);

  return (
    <div id="map" style={{ width: "100%", height: "100%" }}></div>
  );
}
